"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  font-weight: ", ";\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  font-size: ", ";\n  line-height: calc(", " * 1.4);\n  max-height: calc(", " * 1.4 * 2);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  position: absolute;\n  bottom: ", ";\n  right: ", ";\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  > :not(:last-child) {\n    margin-right: ", ";\n  }\n  > svg {\n    height: ", ";\n    width: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSubtitle = exports.GridTitle = exports.ThumbnailMetricContainer = void 0;

var web_1 = require("@thesisedu/web");

var polished_1 = require("polished");

exports.ThumbnailMetricContainer = web_1.styled.div(_templateObject(), function (props) {
  return props.color ? props.theme[props.color] : (0, polished_1.transparentize)(0.25, props.theme['@gray-7']);
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@font-size-sm'];
}, function (props) {
  return props.theme['@size-xxs'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xxs'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-s'];
});
exports.GridTitle = web_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@size-s'];
}, web_1.FontWeight.SemiBold, function (props) {
  return props.theme['@text-color'];
}, function (props) {
  return props.theme['@font-size-lg'];
}, function (props) {
  return props.theme['@font-size-lg'];
}, function (props) {
  return props.theme['@font-size-lg'];
});
exports.GridSubtitle = web_1.styled.div(_templateObject3(), function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@font-size-sm'];
});